import { Provider, EnvironmentProviders, provideAppInitializer, inject } from '@angular/core';
import {
	provideKeycloak,
	INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
	createInterceptorCondition,
	IncludeBearerTokenCondition,
	withAutoRefreshToken,
	AutoRefreshTokenService,
	UserActivityService,
} from 'keycloak-angular';

import { AdminKeycloakAuthService } from 'projects/admin/src/app/service/admin-keycloak-auth.service';
import { environment } from 'projects/admin/src/environments/environment';
import { ExpirationCookieName } from 'shared/openapi/models/expiration-cookie-name';
import { AuthBaseService } from 'shared/services/auth-base.service';

function sessionRefreshInitializer(authService: AuthBaseService) {
	return async () => {
		await authService.init(ExpirationCookieName.AdminCookieExpiration);
	};
}

const includeBearerTokenInterceptor = createInterceptorCondition<IncludeBearerTokenCondition>({
	urlPattern: /^(?!.*\/assets|.*\/clients\/public).*/,
});

export const keycloakProviders: (Provider | EnvironmentProviders)[] = [
	provideKeycloak({
		config: {
			url: environment.keycloak!.url,
			realm: environment.keycloak!.realm,
			clientId: environment.keycloak!.clientId,
		},
		initOptions: {
			flow: 'standard',
			onLoad: 'login-required',
			silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
		},
		features: [
			withAutoRefreshToken({
				onInactivityTimeout: 'logout',
				sessionTimeout: 1800000,
			}),
		],
		providers: [
			AutoRefreshTokenService,
			UserActivityService,
			{
				provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
				useValue: [includeBearerTokenInterceptor], // Specify conditions for adding the Bearer token
			},
		],
	}),
	{
		provide: AuthBaseService,
		useClass: AdminKeycloakAuthService,
	},
	provideAppInitializer(() => {
		const initializerFn = sessionRefreshInitializer(inject(AuthBaseService));
		return initializerFn();
	}),
];
